import { render, staticRenderFns } from "./split.vue?vue&type=template&id=e6c068f6&"
import script from "./split.vue?vue&type=script&lang=js&"
export * from "./split.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6c068f6')) {
      api.createRecord('e6c068f6', component.options)
    } else {
      api.reload('e6c068f6', component.options)
    }
    module.hot.accept("./split.vue?vue&type=template&id=e6c068f6&", function () {
      api.rerender('e6c068f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/split/split.vue"
export default component.exports